const BANNERS_ROUTES = {
  path: 'banners',
  component: () => import('@/pages/Banners/BannersPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'banners.index',
      component: () => import('@/pages/Banners/BannersPage.vue'),
    },
    {
      path: 'create',
      name: 'banners.create',
      component: () => import('@/pages/Banners/BannersFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'banners.edit',
      component: () => import('@/pages/Banners/BannersFormPage.vue'),
    },
  ],
};

export default BANNERS_ROUTES;
